import React from 'react';
import Chart from 'react-apexcharts';

class WidgetMultiBarGraph extends React.Component {

  render() {
    const table = this.props.table;
    const row = table.length - 1;
    const col = table[0].length - 1;

    const series = [];
    const options = {
      title: {
        text: this.props.name,
        align: 'middle'
      },
      plotOptions: {
        bar: {
          horizontal: false,
          borderRadius: 10,
          dataLabels: {
            total: {
              enabled: true,
              style: {
                fontSize: '13px',
                fontWeight: 900
              }
            }
          }
        },
      },
      xaxis: {
        categories: [],
      },
      legend: {
        position: 'right',
        offsetY: 40
      },
      chart: {
        type: 'bar',
        height: 350,
        stacked: true,
        toolbar: {
          show: true
        },
        zoom: {
          enabled: true
        },
        events: {
          dataPointSelection: (_, __, config) => {
            console.log(config.seriesIndex, config.dataPointIndex);
          }
        }
      }
    };
    
    for(let i = 1; i < row; i++) {
      options.xaxis.categories.push(table[i][0]);
      for(let j = 1; j < col; j++) {
        let innerSeries = series.find(item => item.name === table[0][j]); 
        if(!innerSeries) {
          innerSeries = { name: table[0][j], data: [] };
          series.push(innerSeries);
        }
        innerSeries.data.push(table[i][j]);
      }
    }

    return(
      <div className={`col-md-${this.props.report ? 12 : 4}`}>
        <Chart options={options} series={series} type="bar" height={320} />
      </div>
    );
  }
}
export default WidgetMultiBarGraph;